<template>
  <CurationRenderer :curation="subPage" :parent-curation="cur" />
</template>

<script lang="ts" setup>
definePageMeta({
  qsearch: true,
  pageTransition: {
    name: 'slide-page-right',
    mode: 'out-in',
  },
  middleware(to, from) {
    if (to.meta.pageTransition && typeof to.meta.pageTransition !== 'boolean') {
      let pageFrom = Number(from.params.page || 0)
      let pageTo = Number(to.params.page || 0)
      if (pageFrom < pageTo) {
        to.meta.pageTransition.name = 'slide-page-right'
      } else {
        to.meta.pageTransition.name = 'slide-page-left'
      }
    }
  },
})

const { getPageAndCache } = usePage()
const { meta } = await getPageAndCache()
useHead(meta)

const route = useRoute()
const dataStore = useDataStore()

const cur = computed(() => {
  return dataStore.curation(route.params.curId as string)
})

const pageNumber = computed(() => {
  return Number(route.params.page)
})

const subPage = computed(() => {
  if (
    cur.value &&
    cur.value.subPages &&
    pageNumber.value >= 1 &&
    pageNumber.value <= cur.value.subPages.length
  ) {
    return dataStore.curation(cur.value.subPages[pageNumber.value - 1])
  }
  return null
})
</script>

<style lang="scss" scoped>
</style>
